import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Drawer } from "antd";
import { Header, ReviewItem } from "@/components";
import { useStores } from "@/store";
import "./index.less";

/**评论详情 */
const ReviewDetail = ({
  review,
  onPreview,
  visible,
  setVisible,
  onDelete = () => {},
  onEdit = () => {}
}) => {
  const { t } = useTranslation();
  const { restaurantStore } = useStores();
  const [replies, setReplies] = useState([]);
  useEffect(() => {
    if (!review.id) return;
    restaurantStore.getReplies(review.id).then(setReplies);
  }, [review.id]);

  return (
    <Drawer
      className="restaurant-drawer reviews-drawer"
      placement="right"
      closable={false}
      destroyOnClose
      onClose={() => setVisible(false)}
      visible={visible}
    >
      <Header title={t("Details")} onClick={() => setVisible(false)} />
      <ReviewItem
        key={`${review.id}-${review.timestamp}`}
        review={review}
        onPreview={onPreview}
        showRateDetail={true}
        mobile={true}
        showAll={true}
        onDelete={onDelete}
        onEdit={onEdit}
        isShowGallery={true}
      />
      <div hidden={!replies.length}>
        <h3>{t("WEB.comments", { count: replies.length })}</h3>
        <div className="review-comments">
          {replies.map((item) => {
            return (
              <ReviewItem
                mobile={true}
                key={item.id}
                review={item}
                showAll={true}
              />
            );
          })}
        </div>
      </div>
    </Drawer>
  );
};

export default ReviewDetail;
